import { createElement } from 'react';
import invariant from 'tiny-invariant';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var createLCGenerator = function createLCGenerator(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$seed = _ref.seed,
      seed = _ref$seed === void 0 ? 1 : _ref$seed,
      _ref$multiplier = _ref.multiplier,
      multiplier = _ref$multiplier === void 0 ? 16807 : _ref$multiplier,
      _ref$increment = _ref.increment,
      increment = _ref$increment === void 0 ? 0 : _ref$increment,
      _ref$modulus = _ref.modulus,
      modulus = _ref$modulus === void 0 ? 2147483647 : _ref$modulus;

  !(multiplier > 0) ? process.env.NODE_ENV !== "production" ? invariant(false, '`multiplier` must be strictly larger than 0') : invariant(false) : void 0;
  !(multiplier < modulus) ? process.env.NODE_ENV !== "production" ? invariant(false, '`multiplier` must be smaller than `modulus`') : invariant(false) : void 0;
  !(increment >= 0) ? process.env.NODE_ENV !== "production" ? invariant(false, '`increment` must not be negative') : invariant(false) : void 0;
  !(increment < modulus) ? process.env.NODE_ENV !== "production" ? invariant(false, '`increment` must be smaller than `modulus`') : invariant(false) : void 0;
  !(seed >= 0) ? process.env.NODE_ENV !== "production" ? invariant(false, '`seed` must not be negative') : invariant(false) : void 0;
  !(seed < modulus) ? process.env.NODE_ENV !== "production" ? invariant(false, '`seed` must be smaller than `modulus`') : invariant(false) : void 0;
  !(seed !== 0 || increment !== 0) ? process.env.NODE_ENV !== "production" ? invariant(false, '`seed` cannot be 0 if `increment` is 0') : invariant(false) : void 0;
  var state = Math.abs(seed);
  return function () {
    var result = (state * multiplier + increment) % modulus;
    state = result;
    return result / modulus;
  };
};

var makeEmptyArray = function makeEmptyArray(length) {
  return Array.apply(null, Array(length)).map(function () {
    return null;
  });
};

var getArrayByFunction = function getArrayByFunction(_ref) {
  var getArrayValue = _ref.getArrayValue,
      length = _ref.length;
  return makeEmptyArray(length).map(getArrayValue);
};

var getSeed = function getSeed(children) {
  return children.split('').reduce(function (accumulator, _currentValue, index) {
    return accumulator + children.charCodeAt(index);
  }, 0);
};

var normalizeBetweenTwoRanges = function normalizeBetweenTwoRanges(val, minVal, maxVal, newMin, newMax) {
  return newMin + (val - minVal) * (newMax - newMin) / (maxVal - minVal);
};

var normaliseArray = function normaliseArray(_ref) {
  var array = _ref.array,
      max = _ref.max,
      min = _ref.min;
  return array.map(function (value) {
    return normalizeBetweenTwoRanges(value, Math.min.apply(Math, array), Math.max.apply(Math, array), min, max);
  });
};

var sortArrayNumerically = function sortArrayNumerically(array) {
  return array.sort(function (a, b) {
    return a - b;
  });
};

var isOdd = function isOdd(number) {
  return number % 2;
};

var fixedStyle = {
  backgroundPosition: 'bottom',
  backgroundRepeat: 'no-repeat',
  backgroundSize: '100% auto',
  display: 'inline',
  fontStyle: 'inherit',
  overflow: 'visible'
};
var UnderlineEmphasis = function UnderlineEmphasis(_ref) {
  var children = _ref.children;

  if (typeof window === 'undefined' || !children || !children.length) {
    return null;
  }

  var width = 20 * children.length;
  var height = 16;
  var seed = getSeed(children);
  var lcGenerator = createLCGenerator({
    seed: seed
  });
  var pointCountArray = getArrayByFunction({
    getArrayValue: lcGenerator,
    length: 3
  });
  var minPointCount = 3;
  var maxPointCount = 5;
  var pointCount = Math.floor(normaliseArray({
    array: pointCountArray,
    max: maxPointCount + 1,
    min: minPointCount
  }).sort()[1]);
  var xArray = getArrayByFunction({
    getArrayValue: lcGenerator,
    length: pointCount
  });
  var yArray = getArrayByFunction({
    getArrayValue: lcGenerator,
    length: pointCount
  });
  sortArrayNumerically(xArray);
  sortArrayNumerically(yArray).reverse();
  var strokeWidth = 4;
  var normalisedXArray = normaliseArray({
    array: xArray.map(function (value, index) {
      return 0.5 + (isOdd(index) ? -1 : 1) * width * (value * 0.5);
    }),
    max: width - strokeWidth,
    min: strokeWidth
  });
  var normalisedYArray = normaliseArray({
    array: yArray.map(function (value) {
      return value * height;
    }),
    max: height - strokeWidth,
    min: strokeWidth
  });
  var pointArray = normalisedXArray.map(function (_value, index) {
    return [normalisedXArray[index], normalisedYArray[index]];
  });
  var pointString = pointArray.map(function (tuple) {
    return tuple.join(',');
  }).join(' ');
  var svgImage = "<svg width=\"" + width + "\" height=\"" + height + "\" viewBox=\"0 0 " + width + " " + height + "\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <polyline points=\"" + pointString + "\" stroke=\"#9855D4\" stroke-width=\"" + strokeWidth + "\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n  </svg>";
  var encodedSvg = window.btoa(svgImage);
  return createElement("em", {
    style: _extends({}, fixedStyle, {
      backgroundImage: "url('data:image/svg+xml;base64," + encodedSvg + "')"
    })
  }, children);
};

export { UnderlineEmphasis };
//# sourceMappingURL=underline-emphasis.esm.js.map
